import * as types from './types'
import http from '@/Plugins/api'

export default {
  setPager({ commit }, data) {
    commit(types.SET_PAGER, data)
  },
  setChecked({ commit }, data) {
    commit(types.SET_CHECKED, data)
  },
  resetWorkout({ commit }, data) {
    commit(types.RESET_WORKOUT, data)
  },
  setWorkoutData({ commit }, data) {
    commit(types.SET_WORKOUT_DATA, data)
  },
  async getWorkouts({ commit }, data) {
    const r = await http.get(`v2/workouts`, {
      params: data,
    })
    commit(types.SET_WORKOUTS, r.data.data)
    return r.data.data
  },
  async editWorkout({ commit }, data) {
    commit(types.SET_WORKOUT, data)
  },
  async getWorkout({ commit }, id) {
    const r = await http.get(`v2/workouts/${id}`)
    commit(types.SET_WORKOUT, r.data.data)
    return r.data.data
  },
  async saveWorkout({ commit }, data) {
    let r = null
    r = await http.post('v2/workouts', data)
    return r.data.data
  },
  async removeWorkout({ commit }, data) {
    const r = await http.post(`v2/workouts/delete`, data)
    return r.data.data
  },
  async getClasses({ commit }, data) {
    const r = await http.get(`v2/workouts/classes`, {
      params: data,
    })
    commit(types.SET_CLASSES, r.data.data)
    return r.data.data
  },
}
